<template>
  <table class="tg" style="undefined;table-layout: fixed; width: 950px">
    <colgroup>
      <col style="width: 120px" />
      <col style="width: 830px" />
    </colgroup>
    <thead>
      <tr>
        <th class="tg-dvsc">모듈명</th>
        <th class="tg-dvsc">기능 구성</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(item, tag) in info" :key="tag">
        <td class="tg-o57c" :id="tag">{{ item.subject }}</td>
        <td class="tg-65iu">{{ item.element }}</td>
      </tr>
    </tbody>
  </table>
</template>
<script>
export default {
  props: {
    info: Array,
  },
}
</script>
<style>
.tg {
  border-collapse: collapse;
  border-color: rgb(204, 204, 204);
  border-spacing: 0;
}
.tg td {
  background-color: #fff;
  border-color: #cccccc6b;
  border-style: solid;
  border-width: 1px;
  color: #333;
  /* font-family: Arial, sans-serif; */
  font-size: 16px;
  overflow: hidden;
  padding: 10px 5px;
  word-break: normal;
}
.tg th {
  background-color: #f0f0f0;
  border-color: #cccccc6b;
  border-style: solid;
  border-width: 1px;
  color: #333;
  /* font-family: Arial, sans-serif; */
  font-size: 16px;
  font-weight: normal;
  overflow: hidden;
  padding: 10px 5px;
  word-break: normal;
}
.tg .tg-dvsc {
  background-color: rgb(5, 56, 168);
  border-color: #cccccc6b;
  color: #fff;
  text-align: center;
  vertical-align: top;
}
.tg .tg-65iu {
  border-color: #cccccc6b;
  text-align: left;
  vertical-align: top;
  padding: 10px 2px 10px 12px;
  /* color:rgba(0, 0, 0, 0.897) */
}
.tg .tg-o57c {
  border-color: #cccccc6b;
  text-align: center;
  /* vertical-align: top; */
  font-weight: 700;
}
</style>
